import { errMsg } from '@/components/PageElement/ErrorMessage';
import { successMsg } from '@/components/PageElement/SuccessMessage';
import { setMintWallet } from 'api/raffle/raffle_entry_mint_wallet';
import classNames from 'classnames';
import { blockChainIcon } from 'lib/blockChain';
import {
  AlertCircleContainedFill,
  CheckContainedFill,
  Circle,
} from 'lib/lucky-x-icons-2';
import { addressFormat } from 'lib/nicknameFormat';
import React, { useCallback } from 'react';
import { setRaffleMintWallet } from 'store/features/raffleDetailsSlice';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import AddRaffleMintWallet from '../../AddRaffleMintWallet';

interface IMintWalletListProps {
  closeShowMintList: () => void;
  isRegistered?: boolean;
  vanityUrl?: string;
}

const MintWalletList: React.FC<IMintWalletListProps> = ({
  closeShowMintList,
  isRegistered = false,
  vanityUrl = '',
}) => {
  const dispatch = useAppDispatch();
  const {
    hasWonMintWallets,
    mintWallet,
    raffleInfo: { type, status, vanity_url, my_entry, project },
    raffleRegisterResult: { validation },
  } = useAppSelector((state) => state.raffleDetails);
  const { mintWalletListRaffle } = useAppSelector((state) => state.user);

  const handleChangeMintWallet = useCallback(
    async (addr: string) => {
      if (
        (status !== 'ENDED' && type === 'WALLET_COLLECTION') ||
        (type !== 'WALLET_COLLECTION' && status !== 'FINALIZED')
      ) {
        if (!my_entry && !validation) {
          dispatch(setRaffleMintWallet(addr));
          closeShowMintList();
        } else {
          const res = await setMintWallet(addr, vanity_url as string);
          if (res?.code === 0) {
            successMsg('Mint Wallet Updated');
            dispatch(setRaffleMintWallet(addr));
            closeShowMintList();
          } else {
            errMsg(res?.msg);
          }
        }
      }
    },
    [
      closeShowMintList,
      dispatch,
      my_entry,
      status,
      type,
      validation,
      vanity_url,
    ]
  );

  const hasMintedToast = useCallback(
    (addr: string) => {
      if (
        hasWonMintWallets.findIndex(
          (item) => item?.toLocaleLowerCase() === addr?.toLocaleLowerCase()
        ) !== -1
      ) {
        return (
          <div className="group relative ml-2 shrink-0 text-base text-warn-300">
            <AlertCircleContainedFill size={24} className="rotate-180" />
            <div
              className={classNames(
                'absolute -top-2 left-6 hidden w-[160px] rounded-lg bg-neutral-800 px-2 py-2 text-xs font-normal lg:group-hover:block'
              )}
            >
              Address has already won
            </div>
          </div>
        );
      }
    },
    [hasWonMintWallets]
  );

  return (
    <div
      className="grid w-full grid-cols-1 gap-3 rounded-2xl border border-neutral-600 bg-neutral-900 p-3"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {mintWalletListRaffle?.map((item, index) => (
        <div
          key={index}
          onClick={() => {
            if (
              item?.address?.toLocaleLowerCase() !==
              mintWallet?.toLocaleLowerCase()
            ) {
              handleChangeMintWallet(item?.address);
            }
          }}
          className={classNames({
            'cursor-pointer rounded-lg hover:bg-neutral-800':
              mintWallet?.toLocaleLowerCase() !==
              item?.address?.toLocaleLowerCase(),
          })}
        >
          <div className="fiex items-center gap-2 px-4 py-2">
            <div className="flex items-center gap-2 ">
              {mintWallet?.toLocaleLowerCase() ===
              item?.address?.toLocaleLowerCase() ? (
                <CheckContainedFill size={24} className="text-primary-500" />
              ) : (
                <Circle size={24} className="text-neutral-400" />
              )}
              <img
                src={blockChainIcon(project?.blockchain || '')}
                className="h-6 w-6 rounded-full"
                alt=""
              />
              <div>
                {item?.name && (
                  <span className="max-w-[120px] truncate">{item.name} -</span>
                )}
                {addressFormat(item?.address)}
              </div>
              {hasMintedToast(item?.address)}
            </div>
          </div>
        </div>
      ))}

      {isRegistered && (
        <div className="flex items-center justify-center ">
          <AddRaffleMintWallet
            isRegistered={isRegistered}
            vanityUrl={vanityUrl}
          />
        </div>
      )}
    </div>
  );
};

export default MintWalletList;
